import React, { useEffect, useState } from "react";
import footerLogo from "../../images/footer_logo.svg";
import facebookImg from "../../images/facebook.svg";
import linkedinImg from "../../images/linkedin.svg";
import instaImg from "../../images/instagram.svg";
import { GetApi, PostApi } from "../../api/api-service";
import { API_Path, companyName, emailID, UAENum } from "../../Const";
import { toast } from "react-toastify";
import { Link, useLocation } from "react-router-dom";
import { RELocation, REMail, RETelephone } from "../../components/icons/IconSvg";

export default function Footer() {
    const [emailId, setEmailId] = useState("");
    const [CountryName, setCountryName] = useState("");
    const [loader, setLoader] = useState(false);
    const [errorFlag, setErrorFlag] = useState({ text: "", valid: false });

    const location = useLocation();

    useEffect(() => {
        setErrorFlag({ text: "", valid: false });;
    }, [location.pathname]);

    const getCountryCode = () => {
        const GetCountryCodeData = new Promise((resolve) => {
            resolve(GetApi(API_Path.getcountrycodeIp));
        });
        GetCountryCodeData.then((res) => {
            const data = res.data;
            setCountryName(data.country_name);
        });
    };

    const validateEmail = (email) => {
        const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return regex.test(email);
    };
    const handleEmail = (e) => {
        const value = e.target.value;
        setEmailId(value);
        if (value.length === 0) {
            setErrorFlag({ text: "Email address is required.", valid: true });
        } else if (!validateEmail(value)) {
            setErrorFlag({ text: "Email address is invalid.", valid: true });
        } else {
            setErrorFlag({ text: "", valid: false });
        }
    };

    const setSubmitData = async () => {
        if (emailId.length === 0) {
            setErrorFlag({ text: "Email address is required.", valid: true });
        } else if (!validateEmail(emailId)) {
            setErrorFlag({ text: "Email address is invalid.", valid: true });
        } else {
            setErrorFlag({ text: "", valid: false });
            if (!errorFlag.valid) {
                try {
                    getCountryCode();
                    let data = { email: emailId, country: CountryName };
                    setLoader(true);
                    let res = await PostApi(API_Path.addSubscriber, data);
                    if (res.data.success) {
                        setEmailId("");
                        toast.success(res.data.message);
                    } else toast.error(res.data.message);
                    setLoader(false);
                } catch (error) {
                    console.error("Error:", error);
                }
            }
        }
    };

    return (
        <footer className="footer-sec">
            <div className="container">
                <div className="footer-info">
                    <div className="row">
                        <div className="col-lg-3 col-md-6 col-sm-12">
                            <div className="footer-inner">
                                <img src={footerLogo} alt="Lead track" />
                                {/* <p>{companyName} is the leading property classifieds website in the UAE connecting buyers, investors, landlords, sellers and brokers to facilitate various real estate requirements in a user-friendly manner.</p> */}
                                <p>Connecting buyers, sellers, investors, and real estate professionals through a modern platform built for {companyName} property decisions.</p>
                            </div>
                            <div className="contact-inner">

                                <div className="contact-info">
                                    {/* <img src={footerCall} alt="" /> */}
                                    <RETelephone/>
                                    <p>{UAENum}</p>
                                </div>
                                <div className="contact-info">
                                    {/* <img src={footerMail} alt="" /> */}
                                    <REMail />
                                    <p>{emailID}</p>
                                </div>
                                <div className="contact-info">
                                    {/* <img src={footerMap} alt="" /> */}
                                    <RELocation />
                                    <p>5th floor office no 510, Opal Tower, Business bay Dubai, UAE</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="footer-link-sec">
                                <div>
                                    <div className="contact-info-title">
                                        <p>Quick links</p>
                                    </div>
                                    <div className="footer-link">
                                        <ul>
                                            <li>
                                                <Link to="/terms-of-use">Terms of use</Link>
                                            </li>
                                            <li>
                                                <Link to="/privacy-policy">Privacy Policy</Link>
                                            </li>
                                            <li>
                                                <Link to="/blog">Blog</Link>
                                            </li>
                                            <li>
                                                <Link to="/news">News and Artical</Link>
                                            </li>
                                            <li>
                                                <Link to="/contact-us">Contact Support</Link>
                                            </li>
                                            <li>
                                                <Link to="/faqs">FAQs</Link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div>
                                    <div className="contact-info-title">
                                        <p>Popular house</p>
                                    </div>
                                    <div className="footer-link">
                                        <ul>
                                            <li>
                                                <Link to="/property/for-sale/categories=villa" reloadDocument>
                                                    Villa
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="/property/for-sale/categories=bungalow" reloadDocument>
                                                    Bungalow
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="/property/for-sale/categories=penthouse" reloadDocument>
                                                    Penthouse
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="/property/for-sale/categories=building" reloadDocument>
                                                    Building
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="/property/for-sale/categories=apartment" reloadDocument>
                                                    Apartments
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="/property/for-sale/categories=plot">Plot</Link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-sm-12">
                            <div>
                                <div className="contact-info-title">
                                    <p>Newsletter</p>
                                </div>
                                <div className="footer-link">
                                    <p>Sign up to receive the latest articles</p>
                                    <div className="footer-text-box">
                                        <input type="text" placeholder="Your email address" value={emailId} className={errorFlag.valid ?"error-bdr" :""} onChange={(e) => handleEmail(e)} />
                                        {errorFlag.valid && <span>{errorFlag.text}</span>}
                                    </div>
                                </div>
                                <div className="footer-btn">
                                    <button className="button" onClick={setSubmitData} disabled={loader}>
                                        Subscribe
                                        {loader && <span className="spinner-border spinner-border-sm ms-2" aria-hidden="true"></span>}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="policy-footer">
                    <div className="copyright-text">
                        <p>Copyright © 2026 - {companyName}.</p>
                    </div>
                    <div className="footer-social-icon">
                        <span>Follow Us:</span>
                        {/* <a href="https://www.facebook.com/nhgulf" rel="noreferrer" target="_blank">
                            <img src={facebookImg} alt="facebook" />
                        </a> */}
                        <a href="/">
                            <img src={facebookImg} alt="facebook" />
                        </a>
                        {/* <a
                            href="https://www.linkedin.com/authwall?trk=bf&trkInfo=AQGlZhkzYcXuEgAAAZk4X7dIvoPW_vHlYcht9xYxWEf268g4rjrQCtCNa-kRxz2U64rrUTJf5o1TdNNV2BlRjWzTEIuB2XN64rOatH1Ri2ML1eyVP486McGiXRQxU2AOmMgDiAA=&original_referer=&sessionRedirect=https%3A%2F%2Fwww.linkedin.com%2Fcompany%2Fnhgulf%2F"
                            rel="noreferrer"
                            target="_blank"
                        > */}
                        <a href="/" rel="noreferrer">
                            <img src={linkedinImg} alt="linkedin" />
                        </a>
                        {/* <a href="https://www.instagram.com/nhreal.estate/#" rel="noreferrer" target="_blank">
                            <img src={instaImg} alt="instagram" />
                        </a> */}
                        <a href="/" rel="noreferrer">
                            <img src={instaImg} alt="instagram" />
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    );
}
